export default __webpack_public_path__ + "static/media/Landing.220bec55.svg";